import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { AppService } from '../../../services/app.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-website-header',
  templateUrl: './website-header.component.html',
  styleUrl: './website-header.component.scss'
})
export class WebsiteHeaderComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<void>();
  isScrolled = false;
  isMobileMenuOpen = false;
  showDropdown = false;

  categories: any[] = [];

  constructor(private appService: AppService) { }

  ngOnInit(): void {
    this.appService.getAllCategories()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.categories = data || [];
        },
        error: (err) => {
          console.error('Error loading categories', err);
        }
      });
  }

  @HostListener('window:scroll')
  onWindowScroll() {
    this.isScrolled = window.scrollY > 40;
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  closeMobileMenu() {
    this.isMobileMenuOpen = false;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
